import React, { memo } from 'react'
import ReactDiffViewer from 'react-diff-viewer'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

const DiffViewer = memo(({ oldCode, newCode, hasEdited }) => (
  <DiffStyle>
    <ReactDiffViewer
      oldValue={oldCode}
      newValue={newCode}
      showDiffOnly={hasEdited}
      splitView={hasEdited}
      hideLineNumbers={!hasEdited}
    />
  </DiffStyle>
))

const DiffStyle = styled.div`
  table {
    font-size: ${props => props.theme.sizes.xs};
  }
`

DiffViewer.propTypes = {
  oldCode: PropTypes.string,
  newCode: PropTypes.string,
  hasEdited: PropTypes.bool,
}

DiffViewer.defaultProps = {
  oldCode: '',
  newCode: '',
  hasEdited: false,
}

export default DiffViewer
